onReady(($) => {
    $('.request-demo')
        .each((index, module) => {
            let $module = $(module)
            $('.testimonial', $module)
                .slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 200,
                    autoplaySpeed: 5000,
                    infinite: true,
                    autoplay: true,
                    arrows: false,
                    dots: true,
                    fade: false,
                });
        });
});
